import React from 'react';
import type { CampaignTag } from '../../types/campaign';

interface TagBadgeProps {
  tag: CampaignTag;
  onClick?: () => void;
  onRemove?: () => void;
  removable?: boolean;
  clickable?: boolean;
}

export const TagBadge: React.FC<TagBadgeProps> = ({
  tag,
  onClick,
  onRemove,
  removable = false,
  clickable = false,
}) => {
  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium ${
        clickable ? 'cursor-pointer hover:opacity-80' : ''
      }`}
      style={{
        backgroundColor: `${tag.color}20`,
        color: tag.color,
        border: `1px solid ${tag.color}40`,
      }}
      onClick={clickable ? onClick : undefined}
    >
      <span>{tag.name}</span>
      {removable && onRemove && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            onRemove();
          }}
          className="hover:bg-gray-200 rounded-full p-0.5"
          aria-label={`Remove ${tag.name} tag`}
        >
          <svg
            className="w-3 h-3"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      )}
    </span>
  );
};

TagBadge.displayName = 'TagBadge';
